module.exports = __webpack_public_path__ + "static/media/9.65f5720b.jpg";